import { Box, Divider, FormLabel } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import type { SourcingEventV2Dto } from "../../../../../autogen/bff-api";
import { ContractDurationField } from "./ContractDurationField";
import { ContractOptionsField } from "./ContractOptionsField";

interface Props {
  eventId: string;
  event: SourcingEventV2Dto;
}

export const ContractPeriodSection = ({ eventId, event }: Props) => {
  const { t } = useTranslation();

  return (
    <Box borderWidth="1px" borderRadius="lg" p="5" mb="8">
      <FormLabel fontWeight="bold">{t("Contract period")}</FormLabel>
      <ContractDurationField eventId={eventId} event={event} />
      <Divider my="4" />
      <ContractOptionsField eventId={eventId} event={event} />
    </Box>
  );
};
